import { useEffect, useRef, useState } from "react";

const useTimer = () => {
  const [time, setTime] = useState(0);
  const [isRunning, setIsRunning] = useState(false);
  const timerRef = useRef(null);

  useEffect(() => {
    if (isRunning) {
      timerRef.current = setTimeout(() => {
        setTime((prevTime) => prevTime + 1);
      }, 1000);
    } else {
      clearTimeout(timerRef.current);
    }
  }, [time, isRunning]);

  const startTimer = () => {
    setIsRunning(true);
  };

  const stopTimer = () => {
    setIsRunning(false);
  };

  const resetTimer = () => {
    setTime(0);
  };

  useEffect(() => {
    return () => {
      clearTimeout(timerRef.current);
    };
  }, []);

  return { time, isRunning, startTimer, stopTimer, resetTimer };
};

export default useTimer;
